// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vOI0","rightAdornment":"Header_rightAdornment__2IN3v"};